import React, { useEffect } from 'react';
import SIdebar from './SIdebar';
import angularData from '../Data/angular';
import AOS from 'aos';
import 'aos/dist/aos.css';
import { useLocation } from 'react-router-dom';


const Angular = () => {
  const location = useLocation()
  useEffect(() => {
    AOS.init({
      duration: 1000,
    });
  }, []);

  const handleLink = (link) => {
    window.location.href = link;
  };

  const renderAngularProjects = () => {
    return angularData.map((project) => (
      <div className="card" style={{ width: '18rem' }} key={project.id}>
        <img
          className="card-img-top"
          src={project.image}
          alt="cap"
          data-aos="flip-left"
          data-aos-easing="ease-out-cubic"
          data-aos-duration="2000"
        />
        <div className="card-body" data-aos="fade-down">
          <h5 className="card-title">{project.title}</h5>
          <button
            type='button'
            className="btn btn-primary long"
            onClick={() => handleLink(project.link)}
          >
            Go page
          </button>
        </div>
      </div>
    ));
  };

  return (
    <div>
      <SIdebar local={location.pathname}/>
      <h1 className='w3-container w3-teal project'>PROJ.ANGULAR</h1>
      <div className='projetos'>{renderAngularProjects()}</div>
      <h4>Copyright &copy; 2023</h4>
    </div>
  );
};

export default Angular;
